import React, { useState } from 'react'
import TagPrinterManager from '../components/TagPrinterManager'
import BatchMovementTag from '../components/Tags/BatchMovement/BatchMovementTag'
import { ReceivementShelfTag } from '../components/Tags/ReceivementShelfTag'

export function useLabelPrinting({ onFinish, operatorName = '' }) {
  const [labels, setLabels] = useState([])
  const [showingModal, setShowingModal] = useState(false)

  const showModalLabelPrinting = (batches, operator) => {
    setShowingModal(true)

    const tags = batches?.map((batch) => {
      const productDescription =
        batch.modelId === null ? 'PRODUTO NÃO CADASTRADO' : batch.description

      const qtdTotal = batch.total - batch.damageQuantity

      const standardTagObj = {
        productDescription,
        modelId: batch.modelId,
        lotId: batch.batchId,
        expirationDate: batch.expirationDate.format('DD/MM/YYYY'),
        qty: qtdTotal,
        damageQuantity: batch.damageQuantity,
        street: batch.addressNotGondola?.rua,
        measureUnity: batch.measureUnit?.isKg ? ' KG' : ' UN',
        receivementDate: batch.createdAt.format('DD/MM/YYYY'),
        receivementHour: batch.createdAt.format('HH:mm:ss'),
        operatorName: operator ?? operatorName,
        fc: batch.fc?.name,
        addressTag: batch.addressTag,
        productCode: batch.productCode,
        batchNumber: batch.batchNumber,
        suggestedStorageReceivement: batch.suggestedStorageReceivement,
      }

      const directShelfObj = {
        entryDateAndHour: batch.createdAt.format('DD/MM/YYYY HH:mm:ss'),
        batchId: batch.batchId,
        modelShopper: batch.modelId,
        barcode: batch.barcode,
        description: batch.description,
        warehouse: batch.warehouse,
        street: batch.street,
        shelfPallet: batch.shelfPallet,
        binPosition: batch.binPosition,
        fc: batch.fc?.name,
        productCode: batch.productCode,
        batchNumber: batch.batchNumber,
        addressTag: batch.addressTag,
      }

      if (batch.isDirectShelf) {
        return <ReceivementShelfTag obj={directShelfObj} />
      } else {
        return <BatchMovementTag
          key={standardTagObj.lotId}
          obj={standardTagObj}
          isProductNotFound={batch.modelId === null}
        />
      }      
    })

    setLabels(tags)
  }

  const labelPrintingComponent = (
    <TagPrinterManager
      showTagModal={showingModal}
      setShowTagModal={setShowingModal}
      labelsToPrint={labels}
      setLabelsToPrint={setLabels}
      donePrint={() => {
        setShowingModal(false)
        onFinish()
      }}
    />
  )

  return { showModalLabelPrinting, labelPrintingComponent }
}
